import Separator from "components/Separator";
import { useEffect, useMemo } from "react";
import ReactGA from "react-ga";
import { Helmet } from "react-helmet";
import { Outlet, useLocation } from "react-router-dom";
import Track, { microsoftCode } from "services/track";
import { isOrg } from "utils";
import Header from "./Header";
import { RouteConstants } from "routes/RouteConstants";
import { useSelector } from "react-redux";

const Layout = () => {
  const location = useLocation();
  const { isAuth } = useSelector(state => state.Auth);

  useEffect(() => {
    if (isOrg) {
      ReactGA.initialize("UA-86106221-2");
      Track.googleAds();
      Track.facebookAds();
      Track.linkedinAds();
    }
  }, []);

  useEffect(() => {
    if (isOrg) {
      ReactGA.pageview(location.pathname);
      Track.microsoftAds(location.pathname);
    }
  }, [location.pathname]);

  const isHeaderNotDisplay = useMemo(() => {
    return (
      !![RouteConstants.acceptInvitation].includes(location.pathname) ||
      location.pathname?.includes("/invoice") ||
      !isAuth
    );
  }, [isAuth, location.pathname]);

  return (
    <>
      {!isHeaderNotDisplay && !!isAuth && (
        <>
          <Separator />
          <Header />
        </>
      )}
      <div className={!isHeaderNotDisplay ? "main_part" : ""}>
        <Outlet />
      </div>
      {isOrg && (
        <Helmet>
          <script
            type="text/javascript"
            src="https://widget.wickedreports.com/v2/702/wr-a2a2448f01c9fc76282ab47d454a7983.js"
            async
          ></script>
          <script
            type="text/javascript"
            id="hs-script-loader"
            async
            defer
            src="//js.hs-scripts.com/6253593.js"
          ></script>
          <script>{microsoftCode}</script>
        </Helmet>
      )}
    </>
  );
};

export default Layout;
